__turbopack_context__.v({
  "header": "App-module__j0npwW__header",
  "headerContainer": "App-module__j0npwW__headerContainer",
  "logo": "App-module__j0npwW__logo",
  "rightSection": "App-module__j0npwW__rightSection",
});
